/*
Author: Gilang Romadhanu Tartila
*/

import { SET_LOADING, SET_RESOURCES } from '../actions';

const initialState = {
  loading: {
    salesTeams: false,
    branches: false,
    warehouse: false,
    roles: false,
    marketTypes: false,
    users: false,
    countries: false,
    states: false,
    cities: false,
    brands: false,
    clusters: false,
    promotionRules: false,
    brandLetters: false,
  },
  salesTeams: [],
  branches: [],
  warehouse: [],
  roles: [],
  marketTypes: [],
  users: [],
  countries: [],
  states: [],
  cities: [],
  brands: [],
  clusters: [],
  promotionRules: [],
  brandLetters: {
    alphabets: [],
    data: [],
  },
};

const resourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: { ...state.loading, [action.name]: action.data },
      };
    case SET_RESOURCES:
      if (action.more) {
        return {
          ...state,
          [action.name]: state[action.name].concat(action.data),
        };
      } else {
        return { ...state, [action.name]: action.data };
      }
    default:
      return state;
  }
};

export default resourcesReducer;
